var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tier-chip",style:({ background: _vm.tier.color, color: _vm.tier.textColor }),attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', _vm.tier)}}},[_c('tier-icon',{attrs:{"tier":_vm.tier}}),_vm._v("\n    "+_vm._s(_vm.tier.name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }